import React from 'react'
import {SendEmailDialog} from './SendEmailDialog'
import {SendFaxDialog} from './SendFaxDialog'
import {withToggles} from 'startlibs/lib/hocs'

@withToggles('emailDialog', 'faxDialog', 'faxJustSent', 'keyImagesDialog', 'emailJustSent')
export class PDFButtons extends React.Component {

  savePdfUrl(save) {
    const queryString = new URLSearchParams()
    queryString.append('save', save)
    queryString.append('endpoint', this.props.loaderEndPoint)
    return this.props.renderEndPoint + this.props.reportUID + '?' + queryString.toString()
  }

  openJustSent = () => {
    this.props.emailJustSent.open()
    this.props.emailJustSent.closeAfter(1000)()
  }

  openFaxJustSent = () => {
    this.props.faxJustSent.open()
    this.props.faxJustSent.closeAfter(1000)()
  }

  render() {
    const {
      isUploadingKeyImages, sharedReportView, shareDialogMessage, attachedReport, sharingOptions,isPHIPossible,
      fax, sendFaxFetcher, faxDialog, faxJustSent, reportInfoCard,
      emailJustSent, emailDialog, keyImagesDialog, userEmail, UploadingKeyImagesDialog, sendEmailFetcher, reportRecipients, hideSavePdfButton
    } = this.props
    return (
      <div className="buttons-container">
        {
          !sharedReportView &&
          <a
            onClick={isUploadingKeyImages ? keyImagesDialog.toggle : emailDialog.toggle}
            className="button small-button with-icon"
          >
            <span className="icon icon-email"/>E-mail
          </a>
        }
        {
          fax && fax.enabled && !sharedReportView &&
          <a
            onClick={isUploadingKeyImages ? keyImagesDialog.toggle : faxDialog.toggle}
            className="button small-button with-icon"
          >
            <span className="icon icon-fax"/>Fax
          </a>
        }
        {
          faxDialog.isOpen &&
          <SendFaxDialog
            fax={fax}
            sendEmailFetcher={sendFaxFetcher}
            closeDialog={faxDialog.close}
            confirmSent={this.openFaxJustSent}
          />
        }
        <a
          onClick={isUploadingKeyImages ? this.props.keyImagesDialog : undefined}
          href={this.savePdfUrl(true)}
          className="button small-button with-icon"
        >
          <span className="icon icon-download"/>Save PDF
        </a>
        {
          !hideSavePdfButton &&
          <a
            onClick={isUploadingKeyImages ? this.props.keyImagesDialog : undefined}
            href={this.savePdfUrl(false)}
            target="_blank"
            className="button small-button with-icon highlight"
          >
            <span className="icon icon-print"/>Print
          </a>
        }
        {
          emailDialog.isOpen &&
          <SendEmailDialog
            reportRecipients={reportRecipients}
            sendEmailFetcher={sendEmailFetcher}
            userEmail={userEmail}
            shareDialogMessage={shareDialogMessage}
            attachedReport={attachedReport}
            isPHIPossible={isPHIPossible}
            sharingOptions={sharingOptions}
            reportInfoCard={reportInfoCard}
            closeDialog={emailDialog.close}
            confirmSent={this.openJustSent}
          />
        }
        {
          emailJustSent.isOpen &&
          <div className="system-notification success "><span>Report successfully sent via e-mail.</span> <a
            className="icon icon-x" onClick={emailJustSent.close}/></div>
        }
        {
          faxJustSent.isOpen &&
          <div className="system-notification success "><span>Report successfully sent via e-mail.</span> <a
            className="icon icon-x" onClick={emailJustSent.close}/></div>
        }
        {
          keyImagesDialog.isOpen &&
          <UploadingKeyImagesDialog closeDialog={keyImagesDialog.close}/>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/viewer/PdfButtons.jsx